import React from "react";
import { logout } from "../auth";
import { useNavigate, useLocation } from "react-router-dom";

const BACK_ROUTES = {
  "/dynamic":  { label: "Rooms", path: "/" },
  "/curtains": { label: "Rooms", path: "/" },
};

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  const isActive  = (path) => location.pathname === path;
  const backRoute = BACK_ROUTES[location.pathname];

  return (
    <header className="top-bar">
      {/* Back button on sub-pages */}
      {backRoute && (
        <button
          onClick={() => navigate(backRoute.path)}
          style={{
            background: "transparent",
            border: "none",
            color: "#888",
            cursor: "pointer",
            fontSize: "20px",
            padding: "0 8px 0 0",
            display: "flex",
            alignItems: "center",
            lineHeight: 1,
            flexShrink: 0,
          }}
          title={`Back to ${backRoute.label}`}
        >
          ←
        </button>
      )}

      {/* Brand */}
      <div
        className="top-bar__brand"
        onClick={() => navigate("/")}
        style={{ cursor: "pointer" }}
      >
        <div className="top-bar__logo">GM</div>
        <div className="top-bar__brand-text">
          <div className="top-bar__company">GrayMatrix</div>
          <div className="top-bar__subtitle">Automation</div>
        </div>
      </div>

      {/* Nav */}
      <nav className="top-bar__nav">
        <button
          className={`top-bar__nav-link${isActive("/") ? " active" : ""}`}
          onClick={() => navigate("/")}
        >
          Lights
        </button>
        <button
          className={`top-bar__nav-link${isActive("/curtains") ? " active" : ""}`}
          onClick={() => navigate("/curtains")}
        >
          Curtains
        </button>
        <button
          className={`top-bar__nav-link${isActive("/schedules") ? " active" : ""}`}
          onClick={() => navigate("/schedules")}
        >
          Schedules
        </button>
      </nav>

      <button className="top-bar__logout" onClick={handleLogout}>
        Sign Out
      </button>
    </header>
  );
};

export default Header;
